export default __webpack_public_path__ + "static/media/water1.e96c2f07.png";